module.exports = __webpack_public_path__ + "assets/img/bg-female-b94ef683.png";